import UpdateParticipantLanguage from './UpdateParticipantLanguage';

export default UpdateParticipantLanguage;
